import React from "react";
import { useTranslation } from "react-i18next";
import AgileConnection from "../dataManagement/sections/agileConnection";
import DataIntegrity from "../dataManagement/sections/dataIntegrity";
import EasyIntegration from "../dataManagement/sections/easyIntegration";
import WhereData from "../dataManagement/sections/whereData";
import "./dataSources.scss";
import BenefitsDataSources from "./sections/benefitsDataSources";
import ReconcileConfront from "./sections/reconcileConfront";
import SectionDataSources from "./sections/sectionDataSources";
import DataIntegrityDataSource from "./sections/dataIntegritydatasource"


function DataSources() {
  const { t } = useTranslation()
  return (
    <div className="container-data-sources">
      <div className="section-section-data-sources">
        <SectionDataSources />
      </div>
      <div className="section-reconcile-confront">
        <ReconcileConfront />
      </div>
      <div className="section-benefits-data-sources">
        <BenefitsDataSources />
      </div>
      <div className="section-agile-connection">
        <AgileConnection title={t("datasources.agile_connection.title")}>
          <p>{t("datasources.agile_connection.section_text")}</p>
        </AgileConnection>
      </div>
      <div className="section-data-integrity">
        <DataIntegrityDataSource />
      </div>
      <div className="section-easy-integration">
        <EasyIntegration />
      </div>
      <div className="section-whereData">
        <WhereData />
      </div>
    </div>
  );
}

export default DataSources;
